import type { FaireProductEntity } from "../../entity_types/product";

export const p_d8evepdujn: FaireProductEntity = {
  token: "p_d8evepdujn",
  type: "product",
  name: "Raina Pebble Necklace | Pendant Necklace",
  brandToken: "b_eqqcazcfku",
  brandName: "JESSA Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/7189e8300c47dc47b85f13eaad1401bd85c322c48417b2e2ab99431bb4e10e33.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2920935b7c9d1b0a7a024de5eeb5f6b26e71f5d77316c918a883041e10e28ce7.jpeg",
    "https://cdn.faire.com/fastly/6c4f60fd7902e8b5d5450e77d1bf90e11b5a05497c49e7f489a1580286481792.jpeg",
    "https://cdn.faire.com/fastly/62f0ddb6a87567afb8ba61982d8c5d694f00752ddfe4db0c5830804191622926.jpeg",
    "https://cdn.faire.com/fastly/b36a623598ce92e7e2f4f8fdac55b2eff3bac61a4b7464cb5633c046a75eca64.jpeg",
  ],
  priceDollars: 19.2,
  description:
    'The Raina Necklace features a dainty satellite chain and a pebble-like pendant adorned with a CZ stone. A minimalist and elegant accessory that adds a touch of sophistication to any outfit. Perfect for everyday wear or special occasions.\n\n• stainless steel, gold plated\n• 15" with 2" extender',
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:09.118Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
